import { render, staticRenderFns } from "./forovuetify.vue?vue&type=template&id=775d64dc"
import script from "./forovuetify.vue?vue&type=script&lang=js"
export * from "./forovuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports